<template>
  <div>
    <NuxtLayout name="resource" :item="item" />
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

// onMounted(() => {
//   $fetch(`/api/views/update`, {
//     params: { id: props.item.object_id },
//   })
// })
</script>
